// src/hooks/useAuth.js

import { useContext } from "react";
import { AuthContext } from "../auth/AuthContext";

/**
 * Custom hook to access authentication state and methods
 */
export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
};